import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'styled-theming';
import { FiXCircle, FiDelete } from 'react-icons/fi';

import { space } from 'styled-system';

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.dimGrey,
  dark: (props) => props.theme.colors.white,
});

const hoverColor = theme('mode', {
  light: (props) => props.theme.colors.warningDark,
  dark: (props) => props.theme.colors.warning,
});

const CloseButton = styled(FiXCircle)`
  ${space}
  transition: ${(props) => props.theme.animation.quick};
  color: ${iconColor};
  flex-shrink: 0;
  cursor: pointer;
  &:hover {
    color: ${hoverColor};
  }
`;

const DeleteButton = styled(FiDelete)`
  ${space}
  transition: ${(props) => props.theme.animation.quick};
  color: ${iconColor};
  flex-shrink: 0;
  cursor: pointer;
  &:hover {
    color: ${hoverColor};
  }
`;

function EditorDelete(props) {
  const {
    rowIndex, deleteItem, icon,
  } = props;

  const Component = (icon === 'delete') ? DeleteButton : CloseButton;

  return (
    <Component
      size={16}
      onClick={() => deleteItem(rowIndex)}
      data-testid="editor-delete"
    />
  );
}

EditorDelete.propTypes = {
  deleteItem: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
  icon: PropTypes.string.isRequired,
};

export default EditorDelete;
